export default "__VITE_ASSET__CyZw8C$4__";